import { PdfModalEditorProps } from '../types'
import { CSSProperties, useCallback, useState } from 'react'
import { ComponentWithPermissions } from '../../../../../../../../../../../../baseComponents/CreateRoutering/types'
import TwinTrans from '../../../../../../../../../../../../baseComponents/TwinTrans'
import FormRenderer from '../../../../../../../../../../../../forms/FormRenderer'
import { FormElement, FormRender } from '../../../../../../../../../../../../forms/FormRenderer/types'
import { RectangularInputInteger, RectangularInput, InputWithLabelMargin } from '../../../../../../../../../../../../forms/Input'
import SwitchLight from '../../../../../../../../../../../../forms/SwitchLight'
import { checkIntegerValid } from '../../../../../../../../../../../../utils/globals/numbers'
import { valueOrDefaultValue } from '../../../../../../../../../../../../utils/globals/valueOrDefaultValue'
import useTwinTranslation from '../../../../../../../../../../../../utils/hooks/useTwinTranslation'
import { PdfTableElement } from '../../../../../../types'
import { TwinDictionary } from '../../../../../../../../../../../../utils/globals/dictionary'
import useInputColorColors from '../../../../../../../../../../../../utils/hooks/pdf/useInputColorColors'
import { TwinIconToolTip } from '../../../../../../../../../../../../baseComponents/TwinIcon'
import { faEye } from '@fortawesome/pro-light-svg-icons'
import { ButtonsModalSmallCentered, ModalSmallCentered } from '../../../../../../../../../../../../baseComponents/Modal'
import useEditDeleteModal, { EditDeleteModalProps } from '../../../../../../../../../../../../utils/hooks/useEditDeleteModal'
import useTicketVariables from '../../../../../../../../../../../../utils/hooks/pdf/useTicketVariables'

type TableEditorProps = ComponentWithPermissions & TableEditorLogicProps & {}

const TableEditor: React.FC<TableEditorProps> = ({ userPermissions, documentType,  ...logic }) => {
    const { t } = useTwinTranslation()
    const { allRowData, changeAllRowData, setAllRowData } = useTableEditorLogic({ ...logic })
    const { colors } = useInputColorColors()
    const {fontSizes, fontWeights, headerTicketBorder} = useTicketVariables()
    let elements: FormElement<keyof PdfTableElement['extraProps']>[] = []
    if (documentType === 'ticket' || documentType === 'ticketRefund' || documentType === 'voucher' || documentType === 'giftTicket' || documentType === 'cashRegister'){
        elements = [
            {
                name: 'nCols',
                label: t('numberCols', 'Número columnas'),
                component: 'InputWithLabelMarginIntegerStateLess',
                required: true,
                onChange: (value) => changeAllRowData('nCols', value),
                value: allRowData.nCols || ''
            },
            {
                name: 'nRows',
                label: t('numberRows', 'Número filas'),
                component: 'InputWithLabelMarginIntegerStateLess',
                required: true,
                onChange: (value) => changeAllRowData('nRows', value),
                value: allRowData.nRows || ''
            },
            {
                name: 'headerJustifyItems',
                label: t('headerJustifyItemsShort', 'Alineación Horz. Cab.'),
                component: 'CustomSelect',
                onChange: (value) => changeAllRowData('headerJustifyItems', value),
                value: allRowData.headerJustifyItems || 'flex-start',
                items: {
                    'flex-start': { name: t('left', 'Izquierda') },
                    'center': { name: t('center', 'Centro') },
                    'flex-end': { name: t('right', 'Derecha') }
                }
            },
            {
                name: 'headerFontSizeTicket',
                label: t('headerFontSize', 'Tamaño letra cabecera'),
                component: 'CustomSelect',
                items: fontSizes,
                onChange: (value) => changeAllRowData('headerFontSizeTicket', value),
                value: allRowData.headerFontSizeTicket || ''
            },
            {
                name: 'headerFontWeight',
                label: t('headerFontWeight', 'Grosor letra cabecera'),
                component: 'CustomSelect',
                items: fontWeights,
                onChange: (value) => changeAllRowData('headerFontWeight', value),
                value: allRowData.headerFontWeight || ''
            },
            {
                name: 'headerTicketBorder',
                label: t('borderHeader', 'Borde de la cabecera'),
                component: 'CustomSelect',
                items: headerTicketBorder,
                onChange: (value) => changeAllRowData('headerTicketBorder', value),
                value: allRowData.headerTicketBorder || ''
            },
            {
                name: 'cellJustifyItems',
                label: t('cellJustifyItemsShort', 'Alineación Horz. Celda'),
                component: 'CustomSelect',
                onChange: (value) => changeAllRowData('cellJustifyItems', value),
                value: allRowData.cellJustifyItems || 'flex-start',
                items: {
                    'flex-start': { name: t('left', 'Izquierda') },
                    'center': { name: t('center', 'Centro') },
                    'flex-end': { name: t('right', 'Derecha') }
                }
            },
            {
                name: 'typeTable',
                label: t('typeTableDirection', 'Dirección de la tabla'),
                component: 'CustomSelect',
                onChange: (value) => changeAllRowData('typeTable', value),
                value: allRowData.typeTable || 'vertical',
                items: {
                    'vertical': { name: t('vertical', 'Vertical') },
                    'horizontal': { name: t('horizontal', 'Horizontal') },
                }
            },
        ]
    } else {
        elements = [
            {
                name: 'nCols',
                label: t('numberCols', 'Número columnas'),
                component: 'InputWithLabelMarginIntegerStateLess',
                required: true,
                onChange: (value) => changeAllRowData('nCols', value),
                value: allRowData.nCols || ''
            },
            {
                name: 'nRows',
                label: t('numberRows', 'Número filas'),
                component: 'InputWithLabelMarginIntegerStateLess',
                required: true,
                onChange: (value) => changeAllRowData('nRows', value),
                value: allRowData.nRows || ''
            },
            {
                name: 'heightRow',
                label: t('heightRow', 'Altura filas'),
                component: 'InputWithLabelMargin',
                onChange: (value) => changeAllRowData('heightRow', value),
                value: allRowData.heightRow || ''
            },
            {
                name: 'headerBackground',
                label: t('headerBackgroundShort', 'Fondo cabecera'),
                component: 'InputColorDeleteButtonWithMargin',
                onChange: (value) => changeAllRowData('headerBackground', value),
                value: allRowData.headerBackground || '',
                colors: colors
            },
            {
                name: 'headerAlignItems',
                label: t('headerAlignItemsShort', 'Alineación Vert. Cab.'),
                component: 'CustomSelect',
                onChange: (value) => changeAllRowData('headerAlignItems', value),
                value: allRowData.headerAlignItems || 'flex-start',
                items: {
                    'flex-start': { name: t('top', 'Arriba') },
                    'center': { name: t('center', 'Centro') },
                    'flex-end': { name: t('bottom', 'Abajo') }
                },
            },
            {
                name: 'headerJustifyItems',
                label: t('headerJustifyItemsShort', 'Alineación Horz. Cab.'),
                component: 'CustomSelect',
                onChange: (value) => changeAllRowData('headerJustifyItems', value),
                value: allRowData.headerJustifyItems || 'flex-start',
                items: {
                    'flex-start': { name: t('left', 'Izquierda') },
                    'center': { name: t('center', 'Centro') },
                    'flex-end': { name: t('right', 'Derecha') }
                }
            },
            {
                name: 'headerFontSize',
                label: t('headerFontSize', 'Tamaño letra cabecera'),
                component: 'InputWithLabelMargin',
                onChange: (value) => changeAllRowData('headerFontSize', value),
                value: allRowData.headerFontSize || ''
            },
            {
                name: 'headerColor',
                label: t('headerLetterShort', 'Letra cabecera'),
                component: 'InputColorDeleteButtonWithMargin',
                onChange: (value) => changeAllRowData('headerColor', value),
                value: allRowData.headerColor || '',
                colors: colors
            },
            {
                name: 'headerFontWeight',
                label: t('headerFontWeight', 'Grosor letra cabecera'),
                component: 'InputWithLabelMargin',
                onChange: (value) => changeAllRowData('headerFontWeight', value),
                value: allRowData.headerFontWeight || ''
            },
            {
                name: 'cellBorderTop',
                label: t('borderBetweenRowsTop', 'Borde superior entre filas'),
                component: 'InputWithLabelMargin',
                onChange: (value) => changeAllRowData('cellBorderTop', value),
                value: allRowData.cellBorderTop || ''
            },
            {
                name: 'cellBorderBottom',
                label: t('borderBetweenRows', 'Borde entre filas'),
                component: 'InputWithLabelMargin',
                onChange: (value) => changeAllRowData('cellBorderBottom', value),
                value: allRowData.cellBorderBottom || ''
            },
            {
                name: 'cellBorderRight',
                label: t('borderBetweenColumns', 'Borde entre columnas'),
                component: 'InputWithLabelMargin',
                onChange: (value) => changeAllRowData('cellBorderRight', value),
                value: allRowData.cellBorderRight || ''
            },
            {
                name: 'cellPadding',
                label: t('cellPadding', 'Margen interior celdas'),
                component: 'InputWithLabelMargin',
                onChange: (value) => changeAllRowData('cellPadding', value),
                value: allRowData.cellPadding || ''
            },
            {
                name: 'cellAlignItems',
                label: t('cellAlignItemsShort', 'Alineación Vert. Celda'),
                component: 'CustomSelect',
                onChange: (value) => changeAllRowData('cellAlignItems', value),
                value: allRowData.cellAlignItems || 'flex-start',
                items: {
                    'flex-start': { name: t('top', 'Arriba') },
                    'center': { name: t('center', 'Centro') },
                    'flex-end': { name: t('bottom', 'Abajo') }
                }
            },
            {
                name: 'cellJustifyItems',
                label: t('cellJustifyItemsShort', 'Alineación Horz. Celda'),
                component: 'CustomSelect',
                onChange: (value) => changeAllRowData('cellJustifyItems', value),
                value: allRowData.cellJustifyItems || 'flex-start',
                items: {
                    'flex-start': { name: t('left', 'Izquierda') },
                    'center': { name: t('center', 'Centro') },
                    'flex-end': { name: t('right', 'Derecha') }
                }
            },
            {
                name: 'typeTable',
                label: t('typeTableDirection', 'Dirección de la tabla'),
                component: 'CustomSelect',
                onChange: (value) => changeAllRowData('typeTable', value),
                value: allRowData.typeTable || 'vertical',
                items: {
                    'vertical': { name: t('vertical', 'Vertical') },
                    'horizontal': { name: t('horizontal', 'Horizontal') },
                }
            },
        ]
    }
    const sections: FormRender<PdfTableElement['extraProps']> = [
        {
            cols: 3,
            className: 'mt-20',
            title: t('configTable', 'Configuración tabla'),
            elements
        }
    ]
    const parsedFields = valueOrDefaultValue(sections, userPermissions, allRowData)
    return (
        <div className='cpt_text_editor mt-17'>
            <FormRenderer sections={parsedFields} />
            <TableRenderer allRowData={allRowData} setAllRowData={setAllRowData} />
        </div>
    )
}

interface TableEditorLogicProps extends PdfModalEditorProps {}

const useTableEditorLogic = ({ pdfConfigElement }: TableEditorLogicProps) => {
    const [allRowData, setAllRowData] = useState<TwinDictionary>(pdfConfigElement.extraProps  || {})
    const changeAllRowData = useCallback((key: string, value: any) => {
        setAllRowData((old) => {
            const copy = JSON.parse(JSON.stringify(old))
            copy[key] = value
            if (key === 'nCols' || key === 'nRows') {
                if (!copy.data) {
                    copy.data = []
                }
                if (!copy.columnsWidth) {
                    copy.columnsWidth = []
                }
                for (let i = 0; i < (copy.nRows || 0); i++) {
                    if (!copy.data[i]) {
                        copy.data[i] = []
                    }
                    let subData = []
                    for (let k = 0; k < (copy.nCols || 0); k++) {
                        if (copy.columnsWidth[k]) {
                            copy.columnsWidth.push(copy.columnsWidth[k])
                        } else {
                            copy.columnsWidth.push('')
                        }
                        if (copy.data[i][k]) {
                            subData.push(copy.data[i][k])
                        } else {
                            subData.push('')
                        }
                    }
                    copy.data[i] = subData
                }
            }
            return { ...copy}
        })
    }, [])
    return { changeAllRowData, allRowData, setAllRowData }
}


interface TableRendererProps extends TableRenderLogicProps {
    allRowData: TwinDictionary
}

const TableRenderer: React.FC<TableRendererProps> = ({ allRowData, setAllRowData }) => {
    const { t } = useTwinTranslation()
    const { changeElement, editModeOn, setEditModeOn, changeColumnStyle, openModal, setOpenModal, changeViewColumn, changeViewRow } = useTableRenderLogic({setAllRowData})
    if (!parseInt(allRowData.nCols) || !parseInt(allRowData.nRows)) {
        return null
    }
    const renderThis: JSX.Element[] = []
    const header: JSX.Element[] = []
    const finalColums: JSX.Element[] = []
    let columnWidth = 100 / allRowData.nCols
    for (let keyRow = 0; keyRow < allRowData.nRows; keyRow++){
        const row: JSX.Element[] = []
        for (let keyCol = 0; keyCol < allRowData.nCols; keyCol++){
            let style: CSSProperties = {}
            if (keyCol < allRowData.nCols - 1) {
                style.borderRight = '1px solid #000'
            }
            if (keyRow === 0) {
                header.push(<div className='flex justify-center cursor-pointer' onClick={() => setOpenModal({ type: 'edit', allRowData: { nCol: keyCol } })} style={{ width: columnWidth + '%' }}><TwinIconToolTip icon={faEye} message={t('establishConditionOfThisColumn', 'Establecer condición de esta columna')} id={'columnCondition'+keyCol}></TwinIconToolTip><input type='hidden' name={'columnsCondition[' + keyCol + ']'} value={allRowData?.columnsCondition?.[keyCol] || ''}></input></div>)
            }
            row.push(<div key={keyRow + keyCol + 'data'} style={{ width: columnWidth + '%', ...style }} className={editModeOn ? 'hidden' : ''}><RectangularInput name={'data[' + keyRow + '][' + keyCol + ']'} placeholder={t('pressForModifyCell', 'Pulsa para modificar la celda')} value={allRowData?.data?.[keyRow]?.[keyCol] || ''} onChange={(value) => changeElement(keyRow, keyCol, value)} /></div>)
            if (keyCol === 0) {
                finalColums.push(<div className='flex items-center cursor-pointer' onClick={() => setOpenModal({ type: 'create', allRowData: { nRow: keyRow } })} style={{ height: 36 }}><TwinIconToolTip id={'rowCondition' + keyRow} icon={faEye} message={t('establishConditionOfThisRow', 'Establecer condición de esta fila')} ></TwinIconToolTip><input type='hidden' name={'rowsCondition[' + keyRow + ']'} value={allRowData?.rowsCondition?.[keyRow] || ''}></input></div>)
            }
        }
        let style: CSSProperties = {}
        if (!editModeOn && keyRow < allRowData.nRows - 1) {
            style.borderBottom = '1px solid #000'
        }
        renderThis.push(<div key={keyRow + 'row'} className={'flex flex-wrap ' + (!editModeOn || (keyRow === 0 && editModeOn) ? '' : 'hidden')} style={style}>{row}</div>)
    }

    const options = [
        {
            title: t('widthAutoPercent', 'Ancho automatico (porcentaje)'),
            component: RectangularInputInteger,
            fieldName: 'columnsWidth',
        },
        {
            title: t('backgroundColor', 'Color de fondo'),
            component: RectangularInput,
            fieldName: 'backgroundCellColor',
        },
        {
            title: t('textColor', 'Color de letra'),
            component: RectangularInput,
            fieldName: 'textCellColor',
        },
        {
            title: t('characters', 'Caracteres'),
            component: RectangularInput,
            fieldName: 'characters',
        },
        {
            title: t('textAlign', 'Alineación de texto'),
            component: RectangularInput,
            fieldName: 'textJustifyCell',
        },
        {
            title: t('fontWeight', 'Grosor de letra'),
            component: RectangularInput,
            fieldName: 'fontWeightCell',
        },
        {
            title: t('letterSpacing', 'Espacio entre letras'),
            component: RectangularInput,
            fieldName: 'letterSpacingCell',
        },
        {
            title: t('imageSizeCell', 'Tamaño imagen'),
            component: RectangularInput,
            fieldName: 'imageSizeCell',
        },
    ]
    for (const element of options) {
        const row: JSX.Element[] = []
        const keyRow = options.indexOf(element)
        for (let keyCol = 0; keyCol < allRowData.nCols; keyCol++) {
            let style: CSSProperties = {}
            if (keyCol < allRowData.nCols - 1) {
                style.borderRight = '1px solid #000'
            }
            let columnWidth = 100 / allRowData.nCols
            const MyComponent = element.component
            row.push(<div key={keyRow + keyCol + element.fieldName} style={{ width: columnWidth + '%', ...style }} className={editModeOn ? '' : 'hidden'}><MyComponent name={`${element.fieldName}[${keyCol}]`} placeholder={element.title} value={allRowData?.[element.fieldName]?.[keyCol] || ''} onChange={(value) => changeColumnStyle(keyCol, value, element.fieldName)} /></div>)
        }
        renderThis.push(<div key={keyRow + 'row'} className={'flex flex-wrap '}>{row}</div>)
    }

    return (
        <div className='mt-20'>
            <span className='text-red-BA'><TwinTrans transKey='theFinalStylesAreNotRealAreJustForEdit'>Los estilos de esta tabla no son reales, están puestos para que puedas editarla.</TwinTrans></span>
            <SwitchLight active={editModeOn} onChange={setEditModeOn} label={t('editColumnStyles', 'Editar estilo de las columnas')} className='mt-10' />
            <div className='mt-20'>
                <div className='flex items-center pr-25 mb-10'>
                    {header}
                </div>
                <div className='flex'>
                    <div className='border border-black flex flex-col flex-auto'>
                        {renderThis}
                    </div>
                    <div className='min-w-25 flex flex-col items-end'>
                        {finalColums}
                    </div>
                </div>
            </div>
            {openModal?.type === 'edit' ? <ModalViewColumnEdit openModal={openModal} setOpenModal={setOpenModal} changeViewColumn={changeViewColumn} columnCondition={allRowData?.columnsCondition?.[openModal.allRowData?.nCol] || ''} /> : null } 
            {openModal?.type === 'create' ? <ModalViewRowEdit openModal={openModal} setOpenModal={setOpenModal} changeViewRow={changeViewRow} rowCondition={ allRowData?.rowsCondition?.[openModal.allRowData?.nRow] || ''} /> : null}
        </div>
    )
}

interface TableRenderLogicProps {
    setAllRowData: React.Dispatch<React.SetStateAction<TwinDictionary>>
}

const useTableRenderLogic = ({ setAllRowData }: TableRenderLogicProps) => {
    const { openModal, setOpenModal } = useEditDeleteModal()
    const [editModeOn, setEditModeOn] = useState(false)
    const changeElement = useCallback((nRow: number, nCol: number, value: string) => {
        setAllRowData((old) => {
            const copy = JSON.parse(JSON.stringify(old))
            if (copy?.data?.[nRow]?.[nCol] !== undefined) {
                copy.data[nRow][nCol] = value
            }
            return { ...copy }
        })
    }, [setAllRowData])

    const changeColumnStyle = useCallback((nCol: number, value: string, field: string) => {
        setAllRowData((old) => {
            const copy = JSON.parse(JSON.stringify(old))
            if (value) {
                if (!copy[field]) {
                    copy[field] = []
                }
            }
            if (field === 'columnsWidth') {
                const isValid = checkIntegerValid(value)
                if (value === '' || (isValid && parseInt(value) < 100)) {
                    copy.columnsWidth[nCol] = value
                }
            } else {
                copy[field][nCol] = [value]
            }
            return { ...copy }
        })
    }, [setAllRowData])

    const changeViewColumn = useCallback((nCol: number, value: string) => {
        setAllRowData((old) => {
            const copy = JSON.parse(JSON.stringify(old))
            if (!copy.columnsCondition) {
                copy.columnsCondition = [];
            }
            copy.columnsCondition[nCol] = value;
            return { ...copy }
        })
    }, [setAllRowData])

    const changeViewRow = useCallback((nRow: number, value: string) => {
        setAllRowData((old) => {
            const copy = JSON.parse(JSON.stringify(old))
            if (!copy.rowsCondition) {
                copy.rowsCondition = [];
            }
            copy.rowsCondition[nRow] = value;
            return { ...copy }
        })
    }, [setAllRowData])
    return { changeElement, editModeOn, setEditModeOn, changeColumnStyle, openModal, setOpenModal, changeViewColumn, changeViewRow }
}

type ModalViewColumnEditProps = EditDeleteModalProps & ModalViewColumnEditLogicProps & {
    changeViewColumn: (nCol: number, value: string) => void;
}

const ModalViewColumnEdit: React.FC<ModalViewColumnEditProps> = ({ openModal, setOpenModal, changeViewColumn, columnCondition }) => {
    const {t} = useTwinTranslation()
    const { condition, setCondition } = useModalViewColumnEditLogic({ columnCondition })
    return (
        <ModalSmallCentered opened={true} setOpened={() => setOpenModal(null)}>
            <h2><TwinTrans transKey='insertTheConditionOfThisColumn'>Introduce la condición de esta columna</TwinTrans></h2>
            <InputWithLabelMargin label={t('insertTheCondition', 'Introduce tu condicion')} value={condition} onChange={(value) => setCondition(value)}></InputWithLabelMargin>
            <ButtonsModalSmallCentered confirmText={t('save', 'Guardar')} setOpened={() => setOpenModal(null)} onAccept={() => changeViewColumn(openModal?.allRowData.nCol, condition)}></ButtonsModalSmallCentered>
        </ModalSmallCentered>
    )
}

interface ModalViewColumnEditLogicProps {
    columnCondition?: string
}

const useModalViewColumnEditLogic = ({ columnCondition }: ModalViewColumnEditLogicProps) => {
    const [condition, setCondition] = useState(columnCondition || '')
    return { condition, setCondition }
}

type ModalViewRowEditProps = EditDeleteModalProps & ModalViewRowEditLogicProps & {
    changeViewRow: (nRow: number, value: string) => void;
}

const ModalViewRowEdit: React.FC<ModalViewRowEditProps> = ({ openModal, setOpenModal, changeViewRow, rowCondition }) => {
    const { condition, setCondition } = useModalViewRowEditLogic({ rowCondition })
    const {t} = useTwinTranslation()
    return (
        <ModalSmallCentered opened={true} setOpened={() => setOpenModal(null)}>
            <h2><TwinTrans transKey='insertTheConditionOfThisRow'>Introduce la condición de esta fila</TwinTrans></h2>
            <InputWithLabelMargin label={t('insertTheCondition', 'Introduce tu condicion')} value={condition} onChange={(value) => setCondition(value)}></InputWithLabelMargin>
            <ButtonsModalSmallCentered confirmText={t('save', 'Guardar')} setOpened={() => setOpenModal(null)} onAccept={() => changeViewRow(openModal?.allRowData.nRow, condition)}></ButtonsModalSmallCentered>
        </ModalSmallCentered>
    )
}

interface ModalViewRowEditLogicProps {
    rowCondition?: string
}

const useModalViewRowEditLogic = ({ rowCondition }: ModalViewRowEditLogicProps) => {
    const [condition, setCondition] = useState(rowCondition || '')
    return { condition, setCondition }
}

export default TableEditor